import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { SearchIcon } from '../../../appearence/icons/search_icon';
import { Input } from '@chapche/ui';

const ProductPropertiesSearchInput = ({ changeSearchValue }) => {
    const { i18n } = useTranslation();
    const [searchPropertyValue, setSearchPropertyValue] = useState('');

    const changeSearchInputValue = (e) => {
        changeSearchValue(e.target.value);
        setSearchPropertyValue(e.target.value);
    };

    useEffect(() => {
        setSearchPropertyValue('');
        changeSearchValue('');
    }, []);

    return (
        <label className="block__content product__label product__search-label product__tab-property-label relative m-0 block w-full">
            <SearchIcon nameOfClass="product__input-icon product__input-icon_property pointer-events-none absolute top-1/2 left-16 h-20 w-20 -translate-y-1/2" />
            <Input
                fullWidth
                className="product__search-input pl-40"
                placeholder={i18n.t('app.page.product.productFormTab.searchProperties')}
                value={searchPropertyValue || ''}
                onChange={changeSearchInputValue}
            />
        </label>
    );
};

export default ProductPropertiesSearchInput;
